<div class="modal-header border-0">
    <div>
        <h4 class="modal-title fw-semibold mb-1">Staff Locations</h4>
        <p class="text-muted small mb-0">
            <i class="bi bi-geo-alt-fill me-1"></i>
            Latest known locations from mobile app
        </p>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body p-0">
    @if (staffMarkers().length === 0) {
        <div class="p-4">
            <sf-empty message="No staff locations found today"></sf-empty>
        </div>
    } @else {
        <!-- Map Container -->
        <div class="position-relative">
            <google-map mapId="staff-map" [options]="mapOptions" [zoom]="zoom" width="100%" height="600px">
                @for (marker of staffMarkers(); track marker) {
                    <map-advanced-marker
                        [position]="marker.position"
                        [content]="marker.content"
                        [title]="marker.title"></map-advanced-marker>
                }
            </google-map>

            <!-- Staff Count Badge -->
            <div class="position-absolute top-0 start-0 m-3">
                <span class="badge bg-white text-dark shadow-sm px-3 py-2">
                    <i class="bi bi-people-fill me-2"></i>
                    {{ staffMarkers().length }} {{ staffMarkers().length === 1 ? 'Staff Member' : 'Staff Members' }}
                </span>
            </div>

            <!-- View Routes Link -->
            <div class="position-absolute bottom-0 end-0 m-3">
                <a routerLink="/staff-tracker" class="btn btn-light shadow-sm" (click)="activeModal.close()">
                    <i class="bi bi-map me-2"></i>
                    View Full Route History
                </a>
            </div>
        </div>
    }
</div>

<div class="modal-footer border-0 pt-2">
    <button sfButton type="button" color="secondary" (click)="activeModal.close()">Close</button>
</div>
